module.exports = __webpack_public_path__ + "media/images/emblems/Blenio_(Comune)-coat_of_arms-76779137c7390b27997b78d5841874a7.png";